module.exports = __webpack_public_path__ + "img/background_blur1.757d687e.png";